import React, { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import { getDataFromApi } from '../actions/AppActions';
import { useDispatch } from "react-redux";
import { withRouter } from 'react-router-dom';
import DbTasks from '../db/DbTasks';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';

const useStyles = makeStyles({
    table: {
        minWidth: 450,
        maxWidth: 650,
    },

});

function Home(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [birthdays, setBirthdays] = useState([]);

    useEffect(() => {
        new DbTasks().getDataFromDb("api/FirmaInfo/GetBirthdays", {}, { method: "GET" })
            .then(res => {
                console.log("Birthdays, :", res);
                setBirthdays(res);
            })

        return () => {
            console.log("Running cleanup function !");
        }
    }, [])


    return (
        <div>

            <TableContainer component={Paper} align="center">
                <Table className={classes.table}  aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell component="th" align="center" colSpan={3} scope="tableHead" >
                            Geburtstagsliste
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell align="right">Termin</TableCell>
                            <TableCell align="right">Date</TableCell>
                            {/* <TableCell align="right">Carbs&nbsp;(g)</TableCell>
                            <TableCell align="right">Protein&nbsp;(g)</TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {birthdays.map((row) => (
                            <TableRow key={row.id}>
                                <TableCell component="th" scope="row">
                                    {row.fullName}
                                </TableCell>
                                <TableCell align="right">{row.geburtstag !== null ? moment(row.geburtstag).format("DD.MM.YYYY") : ""}</TableCell>
                                <TableCell align="right">{row.termin}</TableCell>
                                {/* <TableCell align="right">{row.carbs}</TableCell>
                                <TableCell align="right">{row.protein}</TableCell> */}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}

export default withRouter(Home);
